import { ActionBarProps } from "./ActionBar";
import { ActionBarMobileProps } from "./ActionBarMobile";

export const isEmptyPremise = (premises: ActionBarProps["premises"]) => {
  return premises?.length === 0;
};

export const isSinglePremise = (premises: ActionBarProps["premises"]) => {
  return premises?.length === 1;
};

export const getSelectedPremise = (
  premises: ActionBarProps["premises"],
  selectedPremiseId: ActionBarProps["selectedPremiseId"]
) => {
  return premises?.find((premise) => premise.premiseId === selectedPremiseId);
};

export const hasSelectedPremise = (
  premises: ActionBarProps["premises"],
  selectedPremiseId: ActionBarProps["selectedPremiseId"]
) => {
  return getSelectedPremise(premises, selectedPremiseId) !== undefined;
};

export const getSelectProps = ({
  premises,
  selectedPremiseId,
  handleOnSelectPremise,
}: {
  premises: ActionBarMobileProps["premises"];
  selectedPremiseId: ActionBarMobileProps["selectedPremiseId"];
  handleOnSelectPremise: ActionBarMobileProps["handleOnSelectPremise"];
}) => {
  const premiseOptions = premises?.map((premise) => ({
    label: premise.premiseName,
    value: premise.premiseId,
  }));

  return {
    options: premiseOptions || [],
    selectedValue: selectedPremiseId,
    onChange: (event: any) => handleOnSelectPremise(event.target.value),
  };
};
